export enum SegmentTypeEnum {
  TEMPORAL_SEGMENT = 'TEMPORAL_SEGMENT',
  STATIC = 'STATIC',
  DYNAMIC = 'DYNAMIC',
  PLAYERS = 'PLAYERS',
  RULES_TRIGGER = 'RULES_TRIGGER',
  RULES_SEGMENT = 'RULES_SEGMENT',
  TEST_SEND_SEGMENT = 'TEST_SEND_SEGMENT',
  BIG_QUERY = 'BIG_QUERY',
}
